import { useEffect, useState } from 'react';

export default function useProgressTimer(retry: number, retryDelay: number) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const stepProgress = 100 / ((retry * retryDelay) / 1000);
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100 - stepProgress) {
          clearInterval(timer);
          return prevProgress;
        }
        return prevProgress + 100 / ((retry * retryDelay) / 1000);
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return progress;
}
